import { useEffect } from "react";
import { useVisibleContainer } from "../hooks/useVisibleContainer";
import { appState } from "../../state";
import { notifyStateChange } from "../../stateBus";
import { loadAlbums } from "../../albumsApi";
import { exitSelectMode } from "../../galleryApi";

// Route-effect component for "/albums" (the list, not a detail). Renders
// nothing - AlbumsListScreen.tsx (mounted unconditionally in AppRoot) owns
// the actual rendering into #albumsListView, reading appState.albums
// reactively.
export function AlbumsRouteScreen() {
  useVisibleContainer("albumsListView");

  useEffect(() => {
    appState.albumsDetailId = null;
    exitSelectMode();
    notifyStateChange();
    loadAlbums();
  }, []);

  return null;
}
